import React from 'react';
import { assets } from '../assets/asset_importer';

const instagramIcon = assets.icons.site.instagram;
const telegramIcon = assets.icons.site.telegram;

// Sponsor logos
const loimu = assets.icons.sponsors.loimu;
const tek = assets.icons.sponsors.tek;
const acc_logo = assets.icons.sponsors.accenture;
const lapland_logo = assets.icons.sponsors.laplandtravels;
const Footer = () => {
  return (
    <footer className="footer">

      {/* === TOP SPONSOR BAR === */}
      <div className="sponsor-bar">
        <h3>Integralis is powered by our sponsors</h3>
        <div className="sponsor-logos">
          <div className="sponsor-logo-wrapper">
            <img src={loimu} alt="Loimu" className="sponsor-logo" />
          </div>
          <div className="sponsor-logo-wrapper">
            <img src={tek} alt="TEK" className="sponsor-logo" />
          </div>
          <div className="sponsor-logo-wrapper">
            <img src={acc_logo} alt="Accenture" className="sponsor-logo" />
          </div>
          <div className="sponsor-logo-wrapper">
            <img src={lapland_logo} alt="Lapland Travels" className="sponsor-logo" />
          </div>
        </div>
      </div>

      {/* === ORIGINAL FOOTER AREA === */}
      <div className="footer-container">
        <div className="footer-content">

          <div className="footer-section">
            <h3>Contact Information</h3>
            <p>integralis(at)helsinki.fi</p>
            <p>+358 44 961 0885</p>
            <p>University of Helsinki</p>
            <p>Pietari Kalmin katu 5</p>
            <p>00560 Helsinki, Finland</p>
          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.instagram.com/integralisry/" aria-label="Instagram">
                <img src={instagramIcon} alt="Instagram" className="social-icon" />
              </a>
              <a href="https://t.me/Integralishub" aria-label="Telegram">
                <img src={telegramIcon} alt="Telegram" className="social-icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Integralis. All rights reserved.</p>
          <a href='/privacy'>Privacy policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
